<template>
    <div>
        <div class="mb-3">
            <label for="queueType" class="form-label">{{ $t('transport.field.queueType') }}</label>
            <select
                name="queueType"
                id="queueType"
                class="form-select"
                :class="[form.errors.queueType ? 'is-invalid' : '']"
                v-model="form.queueType"
            >
                <option value="normal">Normal</option>
                <option value="vip">VIP</option>
            </select>
            <FormError v-if="form.errors.queueType">
                {{ form.errors.queueType }}
            </FormError>
        </div>

        <div class="mb-3">
            <label for="passenger_count" class="form-label">{{ $t('transport.field.passenger_number') }}</label>
            <input
                type="number"
                name="passengerNumber"
                id="passenger_count"
                class="form-control"
                min="1"
                step="1"
                :class="[form.errors.passengerNumber ? 'is-invalid' : '']"
                v-model="form.passengerNumber"
            >
            <FormError v-if="form.errors.passengerNumber">
                {{ form.errors.passengerNumber }}
            </FormError>
        </div>

        <div class="text-end">
            <input type="button" :value="$t('transport.buttons.create')" class="btn btn-primary"  @click.prevent="onCreate"/>
        </div>
    </div>
</template>

<script>
import { useForm } from "@inertiajs/vue3";
import FormError from "../FormError.vue";

export default {
    name: "TransportUpdateForm",
    emits: ["created"],
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: useForm({
                queueType: 'normal',
                passengerNumber: 1,
                formId: this.item.id,
                firstName: this.item.firstname,
                lastName: this.item.lastname,
                formType: this.item.typeForm,
            })
        }
    },
    methods: {
        onCreate() {
            this.form.formId = this.item.id;
            this.form.firstName = this.item.firstname;
            this.form.lastName = this.item.lastname;
            this.form.formType = this.item.typeForm;

            this.form.post('/merchant/transport', {
                preserveScroll: false,
                onSuccess: () => {
                    this.$emit("created");
                },
                onError: (e) => {
                    console.debug(e)
                }
            })
        },
    },
    components: {
        FormError
    }
}
</script>

<style scoped>

</style>
